import script from "./NewTgModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewTgModal.vue?vue&type=script&lang=ts&setup=true"

import "./NewTgModal.vue?vue&type=style&index=0&id=002faf2d&lang=css"

const __exports__ = script;

export default __exports__